export default class DiscussionsBadgeRequirements {
  public totalDiscussionPoints: number;
  public postsCount: number;
  public postPoints: number;
  public reactionsCount: number;
}
